import { render, staticRenderFns } from "./SiteWhy.vue?vue&type=template&id=64ce335e&scoped=true&"
import script from "./SiteWhy.vue?vue&type=script&lang=js&"
export * from "./SiteWhy.vue?vue&type=script&lang=js&"
import style0 from "./SiteWhy.vue?vue&type=style&index=0&id=64ce335e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ce335e",
  null
  
)

export default component.exports